import {PageCommentOutputVo} from '../../common/shared/api/nicolas/vo/comment/PageCommentOutputVo.interface';
import logger from '../../log/logger';
import {CommentItem} from '../generated/types';

export function createCommentItem(comment: PageCommentOutputVo): CommentItem {
  let emoticonObj;
  try {
    emoticonObj = comment.emoticon ? JSON.parse(comment.emoticon) : undefined;
  } catch (e) {
    // 에러가 나더라도 댓글은 보여줘야하기 때문에 넘어갑니다
    logger.err(
      `emotion parsing error. uid:${comment.uid}, emoticon:${comment.emoticon}`,
      e
    );
  }
  return {
    blocked: comment.blocked,
    comment: comment.comment,
    commentStatus: comment.comment_status,
    commentType: comment.comment_type,
    commentUid: comment.comment_uid,
    createDt: comment.create_dt,
    deleted: comment.deleted,
    expose: comment.expose,
    hidden: comment.hidden,
    isBest: comment.is_best,
    likeCount: comment.like_count,
    live: comment.live,
    orderValue: comment.order_value,
    parentUid: comment.parent_uid,
    myReplyCount: comment.my_reply_count,
    replyCount: comment.reply_count,
    seriesId: comment.series_id,
    productId: comment.single_id,
    isSpoiler: comment.is_spoiler,
    title: comment.title,
    userUid: comment.user_uid,
    userThumbnailUrl: comment.user_thumbnail_url,
    userName: comment.user_name,
    liked: comment.liked,
    emoticon: emoticonObj
      ? {
          itemSubType: emoticonObj.item_sub_type,
          resourceId: emoticonObj.resource_id,
          itemId: emoticonObj.item_id,
          itemVer: emoticonObj.item_ver,
        }
      : undefined,
  };
}
